export enum ImpactsName {
  isWater = 'Water',
  isEnergy = 'Energy',
  isWaste = 'Waste',
  isEmissions = 'Emission',
  isInclusion = 'Inclusion',
  isCommunity = 'Community',
}
